import Vue from 'vue';

// directives
import autofocus from './directives/autofocus';
import jump from './directives/jump';
import imgSrc from './directives/imageSrc';
import numberFormatter from './directives/numberFormatter';
import debounceInput from './directives/debounceInput';
import { VueMaskDirective } from 'v-mask';
import { ResourcePlugin } from './plugin-resource.js';
import { AlertForgettable } from './components/AlertForgettable';

// elements
import Calendar from './elements/Calendar.vue';
import Loader from './elements/Loader.vue';
import Modal from './elements/Modal.vue';
import SvgItem from './elements/SvgItem.vue';
import Uploadfile from './elements/Uploadfile.vue';
import { dropdown } from 'vue-strap';
import Maps from './elements/Maps.vue';
import CancelCard from './elements/CancelCard.vue';
import OnLocationOff from './elements/OnLocationOff';
import LocationAutocomplete from './elements/LocationAutocomplete';

// sections
import Header from './sections/Header.vue';

// others
import VueResource from 'vue-resource';
import VueAnalytics from 'vue-analytics';
import VueMoment from 'vue-moment';
import * as VueGoogleMaps from 'vue2-google-maps';
import MultiLanguage from 'vue-multilanguage';

import language from '../services/language';
console.log('imported language', language);

console.log('app language object', language);

let VueTouch = require('vue-touch');
Vue.use(VueTouch, {name: 'v-touch'});

// https://www.npmjs.com/package/vue-multilanguage
if (language.first) {
    language.default = language.first;
    Vue.use(MultiLanguage, language);
} else {
    Vue.use(MultiLanguage, {
        default: 'es',
        es: language
    });
}

Vue.directive('focus', autofocus);
Vue.directive('jump', jump);
Vue.directive('imgSrc', imgSrc);
Vue.directive('mask', VueMaskDirective);
Vue.directive('numberMask', numberFormatter);
Vue.directive('debounceInput', debounceInput);

Vue.component('calendar', Calendar);
Vue.component('loader', Loader);
Vue.component('modal', Modal);
Vue.component('svg-item', SvgItem);
Vue.component('upload-file', Uploadfile);
Vue.component('vue-maps', Maps);

Vue.component('headerApp', Header);
Vue.component('dropdown', dropdown);
Vue.component('cancel-card', CancelCard);
Vue.component('onLocationOff', OnLocationOff);
Vue.component('locationAutocomplete', LocationAutocomplete);

Vue.use(new ResourcePlugin());
Vue.use(new AlertForgettable());

require('./filters.js');

Vue.use(VueResource);

if (process.env.ANALYTICS_API) {
    Vue.use(VueAnalytics, {
        id: process.env.ANALYTICS_API
    });
}

Vue.use(VueMoment);

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MAPS_API,
        libraries: 'places,routes',
        installComponents: true
    }
});



// WEBPACK FOOTER //
// ./src/components/index.js